// Live Gold Price Fetcher
// Created for your jewelry website - updates every 8 hours

(function() {
    // CONFIGURATION - YOU MUST UPDATE THIS
    const API_KEY = 'goldapi-2izdz19mmxrdv6h-io'; // Replace with your actual API key
    const GOLD_PRICE_ID = 'live-gold-price';
    
    const API_URL = `https://www.goldapi.io/api/XAU/USD`;
    
    // >>>>>>> 8-HOUR SETTING - THIS LINE <<<<<<<
    const CACHE_DURATION = 8 * 60 * 60 * 1000; // 8 hours in milliseconds
    
    const CACHE_KEY = 'cachedGoldPrice';
    const CACHE_TIMESTAMP_KEY = 'goldPriceTimestamp';
    
    async function fetchGoldPrice() {
        try {
            const response = await fetch(API_URL, {
                method: 'GET',
                headers: {
                    'x-access-token': API_KEY,
                    'Content-Type': 'application/json'
                }
            });
            
            if (!response.ok) {
                throw new Error(`API error: ${response.status}`);
            }
            
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching gold price:', error);
            return null;
        }
    }
    
    async function getGoldPrice() {
        const cachedPrice = localStorage.getItem(CACHE_KEY);
        const cachedTimestamp = localStorage.getItem(CACHE_TIMESTAMP_KEY);
        const now = Date.now();
        
        // Check if cache is still valid (less than 8 hours old)
        if (cachedPrice && cachedTimestamp && (now - parseInt(cachedTimestamp)) < CACHE_DURATION) {
            console.log('Using cached gold price');
            return JSON.parse(cachedPrice);
        }
        
        console.log('Fetching fresh gold price from API...');
        const freshData = await fetchGoldPrice();
        
        if (freshData && freshData.price) {
            localStorage.setItem(CACHE_KEY, JSON.stringify(freshData));
            localStorage.setItem(CACHE_TIMESTAMP_KEY, now.toString());
            console.log('New gold price cached');
        }
        
        return freshData;
    }
    
    async function updateGoldPrice() {
        const priceElement = document.getElementById(GOLD_PRICE_ID);
        
        if (!priceElement) {
            setTimeout(updateGoldPrice, 1000);
            return;
        }
        
        priceElement.textContent = 'Loading...';
        priceElement.style.opacity = '0.7';
        
        const data = await getGoldPrice();
        
        if (data && data.price) {
            // Convert ounce to gram
            const gramPrice = data.price / 31.1035;
            const formattedPrice = gramPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            
            priceElement.textContent = `$${formattedPrice}`;
            priceElement.style.opacity = '1';
        } else {
            priceElement.textContent = 'Price unavailable';
            priceElement.style.opacity = '0.5';
            setTimeout(updateGoldPrice, 1800000); // 30 minutes
        }
    }
    
    function startGoldPriceUpdates() {
        updateGoldPrice();
        
        // >>>>>>> 8-HOUR UPDATE CHECK - THIS SECTION <<<<<<<
        // Check every hour if cache is older than 8 hours
        setInterval(() => {
            const cachedTimestamp = localStorage.getItem(CACHE_TIMESTAMP_KEY);
            const now = Date.now();
            
            // If no cache or cache is older than 8 hours, update
            if (!cachedTimestamp || (now - parseInt(cachedTimestamp)) >= CACHE_DURATION) {
                console.log('8 hours passed - fetching new price...');
                updateGoldPrice();
            } else {
                console.log('Still within 8 hours - using cached price');
            }
        }, 3600000); // Check every hour
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startGoldPriceUpdates);
    } else {
        startGoldPriceUpdates();
    }
})();